import { mapState, mapActions, mapMutations } from 'vuex'
import flowMixin from '@/modules/Flow/mixins/flowMixin'
import {
  WARRANTY_MODULE_NAME,
  WARRANTY_GET_SINISTER,
  FNOL_UPDATE_EXECUTION_CODE_MUT,
  FNOL_MAVALUE_REPORT_COMPONENT_MUT,
  FNOL_DAMAGES_CONFIRMED_MUT,
  FNOL_NO_DAMAGES,
  FNOL_IS_WLD_FLOW,
  UPDATE_LOADER,
  FNOL_MODULE_NAME
} from '@/store/types'
import maInputText from '@/components/input/modules/text'
import maInputTextarea from '@/components/input/modules/textarea'
import maInputNumber from '@/components/input/modules/number'
import maInputSelect from '@/components/input/modules/select'
import maInputCheckbox from '@/components/input/modules/checkbox'
import maInputRadio from '@/components/input/modules/radio'
import maButtonBlue from '@/components/button-blue'
import maNavbarStepper from '@/components/navbarStepper'
import maInputImgradio from '@/components/input/modules/imgRadio'
import { apiPostFnolFlow } from '@/services/API/fnolFlow'
import { apiGetReport } from '@/modules/Claim/services/reports'
import maDatePicker from '@/components/datePicker'
import maInfoBox from '@/components/infoBox'
import moment from 'moment'
import {
  MESSAGE,
  TEXT,
  TEXTAREA,
  INTEGER,
  FLOAT,
  SELECT,
  RADIO,
  CHECK,
  MULTICHECK,
  SELFCARE,
  DATE,
  IMAGEBUTTON,
  NUMBER
} from '@/constants'
import { FLOW_STATES } from '../../modules/Flow/constants'
import { prepareErrorForSentry } from '@/utils/errorHandling'

export default {
  name: 'fnolFlow',

  mixins: [flowMixin],

  data: function() {
    return {
      availableConnections: [],
      dataComponents: [],
      executionCode: '',
      inputValDate: '',
      errorDate: false,
      dateInputs: [],
      navigatedToSelfcare: false
    }
  },

  computed: {
    ...mapState(FNOL_MODULE_NAME, {
      stateExecutionCode: 'executionCode',
      stateDamagesConfirmed: 'damagesConfirmed',
      stateFnolMavalueReportComponentId: 'fnolMavalueReportComponent',
      stateNoDamages: 'noDamages',
      stateIsWldFlow: 'isWldFlow',
      stateWldConnection: 'wldConnection',
      stateWldWithAppointment: 'wldWithAppointment'
    }),

    areAvailableConnections() {
      return this.availableConnections.length > 0
    },

    checkIfFilled() {
      return this.dataComponents.every((component) => {
        // 1. Info components (no answer needed)
        if (component.isInfoPart || component.type === MESSAGE || component.type === TEXT) {
          return true
        }

        // 2. Optional component (mandatory === false)
        if (component.mandatory === false) {
          return true
        }

        // 3. Validate selection for multicheck, check and image_button
        if (component.type === MULTICHECK) {
          return this.isMulticheckFilled(component)
        }

        if (component.type === CHECK || component.type === IMAGEBUTTON) {
          if (typeof component.value === 'object' && component.value !== null) {
            return Object.values(component.value).some((val) => !!val)
          }
          return !!component.value
        }

        // 4. For radio, select, date, textarea, etc ...
        return (
          component.value !== null &&
      component.value !== undefined &&
      component.value !== ''
        )
      })
    },

    fnolBody: function() {
      return this.getFlowViewOptions
        ? this.getFlowViewOptions.fnol_body
        : undefined
    },

    isNodoInicio() {
      if (this.fnolBody.components[0].id === 'NodoInicio') {
        return true
      }
    }
  },

  components: {
    maInputText,
    maInputTextarea,
    maInputNumber,
    maInputSelect,
    maInputCheckbox,
    maInputRadio,
    maButtonBlue,
    maDatePicker,
    maInputImgradio,
    maNavbarStepper,
    maInfoBox
  },

  methods: {
    ...mapActions(WARRANTY_MODULE_NAME, {
      actWarrantyGetSinister: WARRANTY_GET_SINISTER
    }),
    ...mapMutations(FNOL_MODULE_NAME, {
      mutExecutionCode: FNOL_UPDATE_EXECUTION_CODE_MUT,
      mutFnolMavalueReportComponent: FNOL_MAVALUE_REPORT_COMPONENT_MUT,
      mutDamagesConfirmed: FNOL_DAMAGES_CONFIRMED_MUT,
      mutNoDamages: FNOL_NO_DAMAGES,
      mutIsWldFlow: FNOL_IS_WLD_FLOW
    }),
    ...mapMutations({
      updateLoader: UPDATE_LOADER
    }),

    checkInputDateValue() {
      if (this.inputValDate) {
        this.errorDate = false
      } else {
        this.errorDate = true
      }
    },
    initI18n(lang) {
      if (typeof Storage !== 'undefined') {
        let current
        if (lang) {
          current = this.matchLocale(lang)
        } else if (localStorage.getItem('locale')) {
          current = this.matchLocale(localStorage.getItem('locale'))
        } else {
          current = 'fr'
        }
        this.$i18n.locale = current
        localStorage.setItem('locale', current)
      }
    },

    handleChangeInputDate(component) {
      return function(value) {
        component.value = moment(value).format('DD-MM-YYYY')
      }
    },

    async flowInit(params, fnolBody = null) {
      this.updateLoader(true)
      try {
        const data =
                    fnolBody ||
                    (await apiPostFnolFlow(params).finally(() =>
                      this.updateLoader(false)
                    ))
        this.checkIfContinueToDamages(data)
        this.checkIfFnolFlowIsCompleted(data)
        this.dataComponents = []
        this.updateData(data)
      } catch (error) {
        this.updateLoader(false)
        console.error(error)

        // Create error context tags
        const context = {
          component: 'fnolFlow',
          method: 'flowInit',
          route: this.$route.path
        }
        const tags = prepareErrorForSentry(error, context, { willRedirect: true })

        this.sendSentryError(
          `Error in flowInit: ${error.message || 'Unknown error'}`,
          error.response && error.response.status >= 500 ? 'error' : 'warning',
          tags,
          this.getSinisterId,
          'flowInit'
        )

        this.goToErrorView(error)
      }
    },

    updateData(data) {
      this.buildData(data.components)
      this.availableConnections = data.connections
      this.executionCode = data.execution_code
    },

    buildData(responseComponents) {
      responseComponents.forEach((component) => {
        const componentObject = {
          id: component.id,
          type: component.type,
          literal: component.literal,
          hint: component.hint,
          mandatory: component.mandatory,
          content: component.content
        }

        if (component.type === TEXT || component.type === TEXTAREA) {
          componentObject.value = component.value
        } else if (component.type === DATE) {
          componentObject.value = ''
        } else if (component.type === INTEGER || component.type === NUMBER) {
          componentObject.value = 0
          componentObject.floatDigits = 0
        } else if (component.type === FLOAT) {
          componentObject.value = component.value.toString()
          componentObject.floatDigits = 2
        } else if (component.type === SELECT || component.type === RADIO) {
          componentObject.options = []
          component.options.forEach((option) => {
            const opt = {
              key: option.value,
              value: option.value,
              literal: option.literal
            }
            componentObject.options.push(opt)
          })
          componentObject.options.sort((a, b) => {
            if (a.value === 'G1_C0') return 1
            if (b.value === 'G1_C0') return -1
            return 0
          })
          componentObject.value = component.value !== undefined ? component.value : null
        } else if (component.type === CHECK) {
          const key = component.id
          componentObject.value = {}
          componentObject.value[key] = component.selected
          componentObject.options = [{
            key: component.id,
            value: component.id
          }]
        } else if (component.type === MULTICHECK) {
          componentObject.value = {}
          componentObject.options = []
          component.options.forEach((option) => {
            const opt = {
              key: option.value,
              value: option.value,
              literal: option.literal
            }
            componentObject.options.push(opt)
          })
          componentObject.options.sort((a, b) => {
            if (a.value === 'G1_C0') return 1
            if (b.value === 'G1_C0') return -1
            return 0
          })
        } else if (component.type === IMAGEBUTTON) {
          componentObject.value = {}
          componentObject.options = []
          component.options.forEach((option) => {
            const opt = {
              key: option.value,
              value: option.value,
              literal: option.literal,
              image: option.image_src
            }
            componentObject.options.push(opt)
          })
          componentObject.options.sort((a, b) => {
            if (a.value === 'G1_C0') return 1
            if (b.value === 'G1_C0') return -1
            return 0
          })
        }
        if (component.id === 'titleAuxPlombier' || component.id === 'textAuxPlombier') {
          componentObject.isInfoPart = true
          componentObject.literal = component.literal
        }

        this.dataComponents.push(componentObject)
      })
    },

    isMulticheckFilled(component) {
      return (
        component.type === MULTICHECK &&
                Object.values(component.value).some((value) => !!value)
      )
    },

    setComponentValue(eventValue, dataComponent) {
      dataComponent.value = eventValue
    },

    checkIfContinueToDamages(data) {
      if (data?.components.some((component) => component.type === SELFCARE)) {
        const selfcareComponent = data.components.find(
          (component) => component.type === SELFCARE
        )

        const executionCodeToSave = data.execution_code || this.executionCode

        this.mutExecutionCode(executionCodeToSave)
        this.mutFnolMavalueReportComponent(selfcareComponent.id)

        this.navigatedToSelfcare = true

        if (selfcareComponent.id === 'systema_wld') {
          const wldConnection = data.connections.find(c => c.literal === 'systema_wld')
          this.mutIsWldFlow({
            isWld: true,
            connection: wldConnection?.id
          })
          this.goToView('add-appointment')
        } else {
          this.goToView('damages-view')
        }
      }
    },

    checkIfFnolFlowIsCompleted(data) {
      if (data.connections.length === 0) {
        this.goToNextState()
      }
    },

    resetStateFNOL() {
      this.mutExecutionCode('')
      this.mutFnolMavalueReportComponent('')
      this.mutDamagesConfirmed(false)
      this.mutNoDamages(false)
    },

    clickConnection(connectionId) {
      window.removeEventListener('popstate', this.fnolReload)
      const params = {
        sinister_id: this.getSinisterId,
        components: this.prepareRequestData(),
        connection: connectionId,
        execution_code: this.executionCode,
        id_flux: this.getFnolId,
        lang: localStorage.getItem('locale')
      }
      this.flowInit(params)
    },

    prepareRequestData() {
      const emptiesRemoved = this.removeEmpties()

      return emptiesRemoved.map((component) => {
        if (component.type === MESSAGE) {
          return {
            id: component.id
          }
        } else if (
          component.type === TEXT ||
          component.type === TEXTAREA ||
          component.type === DATE ||
          component.type === RADIO ||
          component.type === INTEGER ||
          component.type === FLOAT ||
          component.type === NUMBER ||
          component.type === SELECT ||
          component.type === IMAGEBUTTON
        ) {
          return {
            id: component.id,
            value: component.value
          }
        } else if (component.type === CHECK) {
          const id = component.id
          return {
            id,
            value: 'true'
          }
        } else if (component.type === MULTICHECK) {
          const entries = Object.entries(component.value)
          const entriesFiltered = entries.filter((entrie) => entrie[1] === true)
          const selectedKeys = entriesFiltered.map((entrie) => entrie[0])
          return {
            id: component.id,
            value: selectedKeys
          }
        }
      })
    },

    removeEmpties() {
      return this.dataComponents.filter((component) => {
        if (
          component.type === TEXT ||
                    component.type === TEXTAREA ||
                    component.type === INTEGER ||
                    component.type === FLOAT ||
                    component.type === SELECT ||
                    component.type === NUMBER
        ) {
          if (component.value === 0) {
            return component
          } else {
            return component.value && component.value.length > 0
          }
        } else if (
          component.type === CHECK ||
                    component.type === MULTICHECK ||
                    component.type === IMAGEBUTTON
        ) {
          return Object.values(component.value).some((value) => value)
        } else {
          return component
        }
      })
    },
    fnolReload(event) {
      window.location.reload()
    }
  },

  async mounted() {
    window.addEventListener('popstate', this.fnolReload)
    const sinisterId = this.getSinisterId
    await this.actWarrantyGetSinister(sinisterId).then((resp) => {
      if (resp.isSinisterFound == null) {
        this.throwNotification(
          this.$t('notifications.loadSinisterKO.title'),
          this.$t('notifications.loadSinisterKO.body'),
          'KO'
        )
      }
    })
  },

  async created() {
    let params
    let fnolResponse = this.fnolBody

    if (
      this.stateExecutionCode &&
      this.stateIsWldFlow &&
      this.getFlowState === FLOW_STATES.SMART
    ) {
      const withAppointment = this.stateWldWithAppointment === true
      fnolResponse = null
      params = {
        sinister_id: this.getSinisterId,
        components: [{
          id: 'systema_wld',
          value: withAppointment ? 'true' : 'false'
        }],
        connection: this.stateWldConnection,
        execution_code: this.stateExecutionCode,
        id_flux: this.getFnolId,
        lang: localStorage.getItem('locale')
      }
      this.mutIsWldFlow({ isWld: false, connection: null, withAppointment: null })
    } else if (
      this.stateExecutionCode &&
            this.stateDamagesConfirmed &&
            this.getFlowState === FLOW_STATES.SMART
    ) {
      fnolResponse = null
      try {
        const res = await apiGetReport(this.getSinisterId)
        params = {
          sinister_id: this.getSinisterId,
          components: [{
            id: this.stateFnolMavalueReportComponentId,
            value: JSON.stringify(res)
          }],
          execution_code: this.stateExecutionCode,
          id_flux: this.getFnolId,
          lang: localStorage.getItem('locale')
        }
      } catch (error) {
        this.goToErrorView(error)
        return
      }
    } else if (
      this.stateExecutionCode &&
            !this.stateDamagesConfirmed &&
            this.stateNoDamages &&
            this.getFlowState === FLOW_STATES.SMART
    ) {
      fnolResponse = null
      params = {
        sinister_id: this.getSinisterId,
        components: [{
          id: 'mavalue',
          value: null
        }],
        execution_code: this.stateExecutionCode,
        id_flux: this.getFnolId,
        lang: localStorage.getItem('locale')
      }
    } else {
      params = {
        sinister_id: this.getSinisterId,
        id_flux: this.getFnolId,
        lang: localStorage.getItem('locale')
      }
    }
    await this.flowInit(params, fnolResponse)
    if (!this.navigatedToSelfcare) {
      this.resetStateFNOL()
    }
  }
}
